import { useNavigate } from '@tanstack/react-router';
import * as React from 'react';

import { RankClientEvolutionScreen } from '@/routes/admin/campaigns/rank-client-evolution-screen';

// =============================================================================
// rank-client-evolution-route.tsx — Adaptateur routeur de l'écran « Évolution par client » (R25, PHASE R).
// =============================================================================
// SURFACE UI DISTINCTE (C3) : zone admin NOMINATIVE (Rang), JAMAIS le panneau de comparaison ANONYME. La
// sélection du périmètre client (SIREN) est FRONT (C5). Le composant de présentation reste testable hors
// routeur. Route sous la zone admin campagnes (« /admin/campaigns/rank-client-evolution »).

export function RankClientEvolutionRoute(): React.JSX.Element {
  const navigate = useNavigate();
  const onBack = React.useCallback((): void => {
    void navigate({ to: '/admin/campaigns' });
  }, [navigate]);

  return <RankClientEvolutionScreen onBack={onBack} />;
}
